import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@contexts/AuthContext";
import { isCurrentUserAdmin } from "@utils/adminUtils";
import { css } from "@emotion/css";
import { HEADER_HEIGHT } from "@components/Header";
import { Flex } from "@components/Flex";
import { Loader } from "./Loader";

const AdminRoute: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Flex
        direction="column"
        align="center"
        justify="center"
        className={loadingStyle}
      >
        <Loader />
      </Flex>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!isCurrentUserAdmin()) {
    return <Navigate to="/color" />;
  }

  return <Outlet />;
};

const loadingStyle = css`
  min-height: calc(100vh - ${HEADER_HEIGHT}px);
`;

export default AdminRoute;